import { AddEventsAndMergeTimestamps, Timestamps } from 'Utils/ChaptersToTimestamps';
import {
  Exercise,
  Lecture,
  NoTimeExercise,
  Section,
  StaffExercise,
  Tutorial,
} from 'Utils/TutorialConfigHelper';
import timestamps from './level19.json';

const Level19 = Tutorial(19, '2:55', [
  Section([Lecture('Six Notes in the Left Hand', '0:00')]),
  Section([
    Lecture('Finger Numbers', '0:12'),
    Lecture('Left Hand Stretch', '0:31'),
    Exercise(
      'Left Hand Stretch',
      '0:54',
      NoTimeExercise({
        centre_align_horizontal: true,
        objectives: [{}, {}],
      }),
      [],
    ),
    Lecture('Left Hand Squeeze', '1:09'),
    Exercise(
      'Left Hand Squeeze',
      '1:35',
      NoTimeExercise({
        centre_align_horizontal: true,
        objectives: [{}, {}],
      }),
      [],
    ),
    Lecture('Left Hand Hop', '1:47'),
    Exercise(
      'Left Hand Hop',
      '2:08',
      NoTimeExercise({
        centre_align_horizontal: true,
        objectives: [{}, {}],
      }),
      [],
    ),
    Exercise(
      'Playing in Time',
      '2:19',
      StaffExercise({
        objectives: [{}],
      }),
      [],
    ),
  ]),
  Section([
    Lecture('Using Both Hands', '2:24'),
    Exercise(
      'Alternating Hands',
      '2:37',
      StaffExercise({
        objectives: [{}, {}],
      }),
      [],
    ),
    Exercise(
      'Hands Together',
      '2:44',
      StaffExercise({
        objectives: [{}, {}],
      }),
      [],
    ),
  ]),
]);

export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level19);
